<template>
    <div>
        <section class="basic-info">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h2 class="section-subtitle">Základní údaje</h2>
                        <v-row>
                            <v-col cols="16" md="10" offset-md="3" sm="14" offset-sm="1">
                                <v-row>
                                    <v-col cols="16" md="4" sm="6" class="blazon">
                                        <user-avatar-view :settings="user.avatar" />
                                        <v-btn @click.stop="editing = true" dark class="primary">Upravit avatara</v-btn>
                                        <user-avatar-builder :current-avatar="user.avatar" v-if="editing" @close="editing = false"/>
                                    </v-col>
                                    <v-col cols="16" offset="0" md="11" offset-md="1" sm="9" offset-sm="1">
                                        <v-form>
                                            <v-text-field
                                                dark
                                                :value="user.nickname"
                                                label="Přezdívka"
                                                :readonly="true"
                                            >
                                            </v-text-field>
                                            <suggest-city v-model="selectedCity" :prefill="selectedCity" />
                                        </v-form>
                                        <v-btn
                                            @click.stop="updateProfile"
                                            :loading="updating"
                                            :disabled="updating"
                                            type="submit"
                                            class="primary basic-info__savechange"
                                            dark
                                        >
                                            Uložit změny
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import SuggestCity from '../Common/SuggestCity';
    import { UPDATE_PROFILE_REQUEST } from '../../store/actions/user';
    import UserAvatarView from '../UserAvatar/UserAvatarView';
    import UserAvatarBuilder from './UserAvatarBuilder';

    export default {
        name: 'UserAvatar',
        components: {
            UserAvatarView,
            SuggestCity,
            UserAvatarBuilder,
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
                team: state => state.team.myTeam,
            }),
        },
        data () {
            return {
                editing: false,
                selectedCity: null,
                updating: false,
            }
        },
        methods: {
            async updateProfile () {
                if (!this.selectedCity) {
                    return;
                }

                try {
                    this.updating = true;
                    this.$store.dispatch('user/' + UPDATE_PROFILE_REQUEST, { cityId: this.selectedCity.id });
                    this.$toast.success('Profil byl aktualizován.');
                } catch (e) {
                    this.$toast.error('Při aktualizaci profilu došlo k chybě. Zkuste to později.');
                } finally {
                    this.updating = false;
                }

            },
        },
        created () {
            if (this.user && this.user.cityId) {
                this.selectedCity = { id: this.user.cityId, label: this.user.cityName };
            }
        },
    }
</script>
